import { apiHelper, getApiBaseUrl } from '../utils/apiHelper';

const API_URL = `${getApiBaseUrl()}/api/org/child-categories`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchChildCategories = (payload) => apiHelper(API_URL, 'POST', payload, headers);